<vx-card>
  <vx-card-header [title]="'pages.dashboard.gettingStarted.title' | transloco">
    <div vxCardHeaderActions class="flex items-center gap-3">
      <span class="flex items-center gap-2">
        <vx-progress-ring
          size="xs"
          [completed]="progress().done"
          [total]="progress().total" />
        <span class="text-13 font-medium tracking-tight text-accent-400">
          {{
            'pages.dashboard.gettingStarted.progress' | transloco: progress()
          }}
        </span>
      </span>
      <vx-icon-button
        icon="dots-three"
        variant="ghost"
        size="sm"
        tone="secondary"
        [ariaLabel]="'pages.dashboard.gettingStarted.menu' | transloco"
        [vxMenuTriggerFor]="checklistMenu" />
      <ng-template #checklistMenu>
        <vx-menu>
          <vx-menu-item icon="eye-slash" (triggered)="dismissed.emit()">
            {{ 'pages.dashboard.gettingStarted.dismiss' | transloco }}
          </vx-menu-item>
        </vx-menu>
      </ng-template>
    </div>
  </vx-card-header>

  @for (item of items(); track item.key) {
    @if (item.done) {
      <div
        class="flex items-center gap-2.5 px-4 pt-4"
        [ngClass]="{ 'pb-4': $last || !items()[$index + 1].done }">
        <vx-icon
          name="check-circle-fill"
          size="md"
          class="shrink-0 text-zinc-200" />
        <span class="text-sm font-medium tracking-tight text-zinc-200">
          <ng-container
            *ngTemplateOutlet="label; context: { $implicit: item.key }" />
        </span>
      </div>
    } @else {
      <div
        class="rounded-xl"
        [ngClass]="{
          'bg-zinc-800 inset-ring inset-ring-zinc-700': expanded() === item.key,
        }">
        <button
          type="button"
          class="flex w-full items-center gap-2.5 rounded-xl p-4 text-left focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
          [ngClass]="{
            'pb-2': expanded() === item.key,
            'hover:bg-zinc-900': expanded() !== item.key,
          }"
          [attr.aria-expanded]="expanded() === item.key"
          (click)="toggle(item.key)">
          <vx-icon
            name="circle-dashed"
            size="md"
            class="shrink-0 text-zinc-200" />
          <span
            class="min-w-0 flex-1 text-sm font-medium tracking-tight text-zinc-200">
            <ng-container
              *ngTemplateOutlet="label; context: { $implicit: item.key }" />
          </span>
          @if (expanded() === item.key) {
            <vx-icon name="caret-down" size="lg" class="text-zinc-500" />
          } @else {
            <vx-icon name="caret-right" size="lg" class="text-zinc-500" />
          }
        </button>

        @if (expanded() === item.key) {
          <div class="flex flex-col items-start gap-4 px-4 pb-4 pl-10.5">
            <p class="text-sm tracking-tight text-zinc-400">
              @switch (item.key) {
                @case ('service') {
                  {{
                    'pages.dashboard.gettingStarted.descriptions.service'
                      | transloco
                  }}
                }
                @case ('incident') {
                  {{
                    'pages.dashboard.gettingStarted.descriptions.incident'
                      | transloco
                  }}
                }
                @case ('monitor') {
                  {{
                    'pages.dashboard.gettingStarted.descriptions.monitor'
                      | transloco
                  }}
                }
                @case ('statuspage') {
                  {{
                    'pages.dashboard.gettingStarted.descriptions.statuspage'
                      | transloco
                  }}
                }
                @case ('notifications') {
                  {{
                    'pages.dashboard.gettingStarted.descriptions.notifications'
                      | transloco
                  }}
                }
              }
            </p>
            @switch (item.key) {
              @case ('service') {
                <vx-button tone="secondary" [routerLink]="['/services', 'new']">
                  {{
                    'pages.dashboard.gettingStarted.actions.service' | transloco
                  }}
                </vx-button>
              }
              @case ('incident') {
                <vx-button
                  tone="secondary"
                  (click)="testIncidentRequested.emit()">
                  {{
                    'pages.dashboard.gettingStarted.actions.incident'
                      | transloco
                  }}
                </vx-button>
              }
              @case ('monitor') {
                <vx-button tone="secondary" [routerLink]="['/monitors', 'new']">
                  {{
                    'pages.dashboard.gettingStarted.actions.monitor' | transloco
                  }}
                </vx-button>
              }
              @case ('statuspage') {
                <vx-button
                  tone="secondary"
                  [routerLink]="['/statuspages', 'new']">
                  {{
                    'pages.dashboard.gettingStarted.actions.statuspage'
                      | transloco
                  }}
                </vx-button>
              }
              @case ('notifications') {
                <vx-button
                  tone="secondary"
                  [routerLink]="['/settings', 'account', 'notifications']">
                  {{
                    'pages.dashboard.gettingStarted.actions.notifications'
                      | transloco
                  }}
                </vx-button>
              }
            }
          </div>
        }
      </div>
    }
  }
</vx-card>

<ng-template #label let-key>
  @switch (key) {
    @case ('service') {
      {{ 'pages.dashboard.gettingStarted.items.service' | transloco }}
    }
    @case ('incident') {
      {{ 'pages.dashboard.gettingStarted.items.incident' | transloco }}
    }
    @case ('monitor') {
      {{ 'pages.dashboard.gettingStarted.items.monitor' | transloco }}
    }
    @case ('statuspage') {
      {{ 'pages.dashboard.gettingStarted.items.statuspage' | transloco }}
    }
    @case ('notifications') {
      {{ 'pages.dashboard.gettingStarted.items.notifications' | transloco }}
    }
  }
</ng-template>
